import { readLogs } from './info-logger/log-fs';

export async function generatePrBody(config: any) {
  const upgradeLogs = await readLogs();

  if (upgradeLogs.length === 0) {
    console.log('No upgrade logs found. Cannot create Pull Request info...');
    return;
  } else {
    const latestUpgradeLog = upgradeLogs[0];

    return `
# Pods Updated

${podList(latestUpgradeLog)}

# Components Updated

* [Vendors::AddressFieldset](https://n2retail.github.io/pod-dashboard/components?path=vendors/address-fieldset)

# Tests Updated

* acceptance/vendors/index
* acceptance/vendors/create

# Remaining Lint Errors

None`;
  }
}
